// extracted by mini-css-extract-plugin
export default {"wrapper":"SinglePage_wrapper__NGdH0","otherActions":"SinglePage_otherActions__97PTe"};